import { Outlet } from 'react-router-dom';
import { Box, Container } from '@mui/material';

/**
 * Public Layout
 * Used for landing page, login, and registration flows
 */
export const PublicLayout = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Outlet />
      </Container>
    </Box>
  );
};
